import {
  Alert,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { FC, useState } from "react";
import { Form } from "assets/styleds";
import * as yup from "yup";
import { pt } from "yup-locale-pt";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useApplyProps } from "hooks/useApplyProps";
import { getError } from "utils";
import { snack } from "components/GlobalSnackbar";
import { LoadingButton } from "@mui/lab";
import { Password } from "components/Inputs/Password";
import { useAppSelector } from "store";
import axios from "axios";
import { Environment } from "configs";
import { EAppType } from "@deltasge/marauders-map";

yup.setLocale(pt);
const objectForm = yup.object({
  usuario: yup.string().required().label("Usuário"),
  senha: yup.string().required().label("Senha"),
});
const schemaForm = objectForm.shape({});
type FormState = yup.InferType<typeof objectForm>;

export const DialogConfirmeLoginSenha: FC<{
  callBack: (result: boolean) => void;
  isRemove?: boolean;
}> = ({ callBack, isRemove = false }) => {
  const [submiting, setSubmiting] = useState(false);

  const {
    usuario: { usuario },
  } = useAppSelector((state) => state);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormState>({
    resolver: yupResolver(schemaForm),
    defaultValues: {
      usuario: "",
      senha: "",
    },
  });

  const applyProps = useApplyProps<FormState>({
    register,
    errors,
    schema: schemaForm,
  });

  const onSubmit = async (payload: FormState) => {
    try {
      setSubmiting(true);
      if (!usuario) {
        throw new Error("Não foi pssóvel encontrar o usuário autenticado");
      }
      const codigoZeroEsqueda = usuario.escolaId.padStart(4, "0");
      await axios.post(
        `${Environment.AUTH_API_URL}/${codigoZeroEsqueda}/auth/${EAppType.Educador}/confirma`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${usuario.token}`,
          },
        }
      );

      callBack(true);
    } catch (error) {
      snack.error(getError(error));
    } finally {
      setSubmiting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)} noValidate>
      <DialogContent>
        <Grid container spacing={2}>
          {isRemove && (
            <Grid item xs={12}>
              <Alert severity="info">
                Esta ação não removerá nenhuma informação do Sistema Delta SGE,
                apenas o vinculo entre as contas.
              </Alert>
            </Grid>
          )}
          {isRemove && (
            <Grid item xs={12}>
              <Typography variant="body1">
                Para continuar informe seu login e senha.
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <TextField autoFocus {...applyProps("usuario")} />
          </Grid>
          <Grid item xs={12}>
            <Password {...applyProps("senha")} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <LoadingButton loading={submiting} variant="outlined" type="submit">
          Confirmar
        </LoadingButton>
      </DialogActions>
    </Form>
  );
};
